import type {IRcnAddressKey} from "../../types/IRcnAddress";
import {findPricesCityByName} from "./resolve_query_diacritics";

// Display only - URLs, keys and exact filters always use the raw RCN values.
const DISPLAY_STREET_PREFIX = /^(ulica|ul\.)\s+/i;
// Also skipped when a street is matched against the query, like the words `sanitizeRcnQueryTokens` drops.
const MATCH_STREET_PREFIX = /^(ulica|ul\.|aleja|al\.)\s+/i;
// The type word RCN puts in front of a street name - kept lower case inside a sentence ("pod adresem ulica Puławska 53").
const STREET_TYPE_PREFIX = /^(ulica|ul\.|aleja|al\.|plac|pl\.|osiedle|os\.|rondo|skwer|bulwar)\s+/i;
const LOWERCASE_CONNECTORS: ReadonlySet<string> = new Set(["i", "w", "z", "na", "nad", "pod", "przy", "do", "od", "o", "im."]);
// Two letters at least - a lone "i", "c" or "v" is a word or a building letter, not a numeral.
const ROMAN_NUMERAL = /^(?=[ivxlcdm]{2,}$)m{0,3}(cm|cd|d?c{0,3})(xc|xl|l?x{0,3})(ix|iv|v?i{0,3})$/;
const LETTERS_AFTER_DIGIT = /(\d)([a-ząćęłńóśźż]+)/g;

const isLetter = (char: string): boolean => char.toLocaleLowerCase("pl") !== char.toLocaleUpperCase("pl");

const capitalizeFirstLetter = (part: string): string => {
    for (let index = 0; index < part.length; index++) {
        if (isLetter(part.charAt(index))) {
            return part.slice(0, index) + part.charAt(index).toLocaleUpperCase("pl") + part.slice(index + 1);
        }
    }

    return part;
};

const formatWord = (word: string, isFirst: boolean): string => {
    if (!isFirst && LOWERCASE_CONNECTORS.has(word)) {
        return word;
    }
    if (ROMAN_NUMERAL.test(word)) {
        return word.toLocaleUpperCase("pl");
    }

    return word.split("-").map(capitalizeFirstLetter).join("-");
};

/** Title case the Polish way: connectors stay lower case unless first, Roman numerals upper case, "-" starts a word. */
const toDisplayCase = (text: string): string =>
    text
        .trim()
        .toLocaleLowerCase("pl")
        .split(/\s+/)
        .map((word, index) => formatWord(word, index === 0))
        .join(" ");

/** "łódź" → "Łódź" (the PRICES_CITIES name), "bielsko-biała" → "Bielsko-Biała". */
export const formatRcnCityName = (rawCity: string): string => findPricesCityByName(rawCity)?.name ?? toDisplayCase(rawCity);

/** "ulica puławska" → "Puławska", "bł. karoliny" → "Bł. Karoliny", "aleja jana pawła ii" → "Aleja Jana Pawła II". */
export const formatRcnStreetName = (rawStreet: string): string => toDisplayCase(rawStreet.trim().replace(DISPLAY_STREET_PREFIX, ""));

/** "1a" → "1A", "7/9" stays, "4a (kl. c)" → "4A (kl. c)". */
export const formatRcnHouseNumber = (rawNumber: string): string =>
    rawNumber.trim().replace(LETTERS_AFTER_DIGIT, (_match, digit: string, letters: string) => `${digit}${letters.toLocaleUpperCase("pl")}`);

/** "ulica puławska" + "53" → "ulica Puławska 53", "aleja jana pawła ii" + "12a" → "aleja Jana Pawła II 12A". */
export const formatRcnAddressName = ({street, number}: Pick<IRcnAddressKey, "street" | "number">): string => {
    const rawStreet = street.trim();
    const typeWord = rawStreet.match(STREET_TYPE_PREFIX)?.[1]?.toLocaleLowerCase("pl");
    const streetName = toDisplayCase(rawStreet.replace(STREET_TYPE_PREFIX, ""));

    return `${typeWord ? `${typeWord} ` : ""}${streetName} ${formatRcnHouseNumber(number)}`;
};

/** "Puławska 257, Warszawa" - the label of an address row, its recent entry and tracking. */
export const formatRcnAddressLabel = ({city, street, number}: IRcnAddressKey): string =>
    `${formatRcnStreetName(street)} ${formatRcnHouseNumber(number)}, ${formatRcnCityName(city)}`;

/** What a street is scored against: the raw name without its type word ("aleja jana pawła ii" → "jana pawła ii"). */
export const getRcnStreetMatchName = (rawStreet: string): string => rawStreet.trim().replace(MATCH_STREET_PREFIX, "");
import type {IRcnAddressKey} from "../../types/IRcnAddress";
import {findPricesCityByName} from "./resolve_query_diacritics";

// Display only - URLs, keys and exact filters always use the raw RCN values.
const DISPLAY_STREET_PREFIX = /^(ulica|ul\.)\s+/i;
// Also skipped when a street is matched against the query, like the words `sanitizeRcnQueryTokens` drops.
const MATCH_STREET_PREFIX = /^(ulica|ul\.|aleja|al\.)\s+/i;
// The type word RCN puts in front of a street name - kept lower case inside a sentence ("pod adresem ulica Puławska 53").
const STREET_TYPE_PREFIX = /^(ulica|ul\.|aleja|al\.|plac|pl\.|osiedle|os\.|rondo|skwer|bulwar)\s+/i;
const LOWERCASE_CONNECTORS: ReadonlySet<string> = new Set(["i", "w", "z", "na", "nad", "pod", "przy", "do", "od", "o", "im."]);
// Two letters at least - a lone "i", "c" or "v" is a word or a building letter, not a numeral.
const ROMAN_NUMERAL = /^(?=[ivxlcdm]{2,}$)m{0,3}(cm|cd|d?c{0,3})(xc|xl|l?x{0,3})(ix|iv|v?i{0,3})$/;
const LETTERS_AFTER_DIGIT = /(\d)([a-ząćęłńóśźż]+)/g;

const isLetter = (char: string): boolean => char.toLocaleLowerCase("pl") !== char.toLocaleUpperCase("pl");

const capitalizeFirstLetter = (part: string): string => {
    for (let index = 0; index < part.length; index++) {
        if (isLetter(part.charAt(index))) {
            return part.slice(0, index) + part.charAt(index).toLocaleUpperCase("pl") + part.slice(index + 1);
        }
    }

    return part;
};

const formatWord = (word: string, isFirst: boolean): string => {
    if (!isFirst && LOWERCASE_CONNECTORS.has(word)) {
        return word;
    }
    if (ROMAN_NUMERAL.test(word)) {
        return word.toLocaleUpperCase("pl");
    }

    return word.split("-").map(capitalizeFirstLetter).join("-");
};

/** Title case the Polish way: connectors stay lower case unless first, Roman numerals upper case, "-" starts a word. */
const toDisplayCase = (text: string): string =>
    text
        .trim()
        .toLocaleLowerCase("pl")
        .split(/\s+/)
        .map((word, index) => formatWord(word, index === 0))
        .join(" ");

/** "łódź" → "Łódź" (the PRICES_CITIES name), "bielsko-biała" → "Bielsko-Biała". */
export const formatRcnCityName = (rawCity: string): string => findPricesCityByName(rawCity)?.name ?? toDisplayCase(rawCity);

/** "ulica puławska" → "Puławska", "bł. karoliny" → "Bł. Karoliny", "aleja jana pawła ii" → "Aleja Jana Pawła II". */
export const formatRcnStreetName = (rawStreet: string): string => toDisplayCase(rawStreet.trim().replace(DISPLAY_STREET_PREFIX, ""));

/** "1a" → "1A", "7/9" stays, "4a (kl. c)" → "4A (kl. c)". */
export const formatRcnHouseNumber = (rawNumber: string): string =>
    rawNumber.trim().replace(LETTERS_AFTER_DIGIT, (_match, digit: string, letters: string) => `${digit}${letters.toLocaleUpperCase("pl")}`);

/** "ulica puławska" + "53" → "ulica Puławska 53", "aleja jana pawła ii" + "12a" → "aleja Jana Pawła II 12A". */
export const formatRcnAddressName = ({street, number}: Pick<IRcnAddressKey, "street" | "number">): string => {
    const rawStreet = street.trim();
    const typeWord = rawStreet.match(STREET_TYPE_PREFIX)?.[1]?.toLocaleLowerCase("pl");
    const streetName = toDisplayCase(rawStreet.replace(STREET_TYPE_PREFIX, ""));

    return `${typeWord ? `${typeWord} ` : ""}${streetName} ${formatRcnHouseNumber(number)}`;
};

/** "Puławska 257, Warszawa" - the label of an address row, its recent entry and tracking. */
export const formatRcnAddressLabel = ({city, street, number}: IRcnAddressKey): string =>
    `${formatRcnStreetName(street)} ${formatRcnHouseNumber(number)}, ${formatRcnCityName(city)}`;

/** What a street is scored against: the raw name without its type word ("aleja jana pawła ii" → "jana pawła ii"). */
export const getRcnStreetMatchName = (rawStreet: string): string => rawStreet.trim().replace(MATCH_STREET_PREFIX, "");
